import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { Button, Grid, Stack } from '@mui/material';

import { FormRoot, RenderFormField } from '@/components';
import { IFileDescriptionForm } from '@/models';

import { useKaseArrestsContext } from '../KaseArrestsContext';

const FileDescriptionForm = () => {
  const {
    arrestDrawer,
    setArrestDrawer,
    currentArrestee,
    currentArrestFile,
    setCurrentArrestee,
  } = useKaseArrestsContext();
  const methods = useForm<IFileDescriptionForm>({
    defaultValues: {},
    mode: 'all',
  });

  const { handleSubmit, watch, reset } = methods;

  const description = watch('description');

  useEffect(() => {
    if (arrestDrawer === 'description') {
      reset({
        description: currentArrestFile?.description,
      });
    }
  }, [arrestDrawer]);

  const onSubmit = async () => {
    if (!currentArrestee?.files?.length) {
      return;
    }

    const files = currentArrestee.files.map((file) => {
      if (file._id === currentArrestFile?._id) {
        file.description = description;
      }
      return file;
    });

    setCurrentArrestee({
      ...currentArrestee,
      files,
    });
    setArrestDrawer(null);
  };

  return (
    <FormProvider {...methods}>
      <FormRoot onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid xs={12} item>
            <RenderFormField
              name="description"
              label="Description"
              type="text"
            />
          </Grid>
        </Grid>
        <Stack flexDirection="row" p={2} justifyContent="flex-end" width="100%">
          <Button
            variant="contained"
            color="inherit"
            size="medium"
            sx={{ mr: 2 }}
            onClick={() => setArrestDrawer(null)}
          >
            Cancel
          </Button>
          <Button
            disabled={!description}
            variant="contained"
            color="error"
            size="medium"
            onClick={handleSubmit(onSubmit)}
          >
            Save
          </Button>
        </Stack>
      </FormRoot>
    </FormProvider>
  );
};

export default FileDescriptionForm;
